import React from "react";
import { useTranslation } from "react-i18next";

export const UkrainiansSaleBanner: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section className="py-48" style={{ backgroundColor: '#FAFAFA' }}>
            <div
                style={{
                    backgroundColor: '#2054c7',
                    color: 'white',
                    textAlign: 'center',
                    padding: '20px',
                    borderRadius: '12px',
                    maxWidth: '80%',
                    margin: '40px auto 20px auto',
                    fontSize: '1.1rem',
                    lineHeight: '1.4',
                    boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
                }}
            >
                {t("Tariffs.UkrainiansSale")} 💙💛
            </div>
        </section>
    );
};

export default UkrainiansSaleBanner;
